import { render, staticRenderFns } from "./monthly-bookkeep.vue?vue&type=template&id=bb1db32c&scoped=true"
import script from "./monthly-bookkeep.vue?vue&type=script&lang=js"
export * from "./monthly-bookkeep.vue?vue&type=script&lang=js"
import style0 from "./monthly-bookkeep.vue?vue&type=style&index=0&id=bb1db32c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1db32c",
  null
  
)

export default component.exports